import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Unde se conecteaza v4 ca sa primeasca date in timp real, si cu ce nume.
 *
 * Contractul lui `GET /api/v2/realtime` (v4/api, App\Platform\RealtimeConfig).
 * Perechea veche sunt `_ss` si `uSession`, scrise de PHP in antetul portalului.
 */
export interface RealtimeConfig {
  /** Adresa serverului de socket, cu bara la final. null = neconfigurat. */
  url: string | null
  /** `/portal`. Portalul il lipea de adresa (`io(_ss + 'portal')`). */
  namespace: string
  /** Adresa de retur a omului, fara numarul filei. Vezi `tabSession`. */
  session: string
}

export const realtimeConfigQuery = queryOptions({
  queryKey: ['realtime'],
  queryFn: () => apiGet<RealtimeConfig>('/realtime'),
  /* Adresa unui server nu se schimba cat sta omul pe ecran. O jumatate de ora,
     ca la `me`: destul cat sa nu se ceara la fiecare deschidere de fila, si nu
     atat cat sa ramana o adresa veche dupa o mutare. */
  staleTime: 30 * 60_000,
})

/**
 * Numarul filei de browser, ca in portal.
 *
 * `public/js/general.js:178-181` scrie in `sessionStorage` un numar la prima
 * incarcare a filei si il lipeste de sesiune:
 *
 *     sessionStorage.setItem("tabID", Math.round(+new Date() / 1000))
 *     tSession = uSession + sessionStorage.getItem("tabID")
 *
 * DE CE. Pe server, `user:<sesiune>` e o cheie cu O SINGURA valoare: `socket.id`
 * al ultimei conexiuni care s-a prezentat cu numele ala. Doua file deschise cu
 * acelasi nume inseamna ca a doua o dezleaga pe prima, tacut - prima cere si nu
 * mai primeste niciodata nimic.
 *
 * `sessionStorage` si nu `localStorage`: e al FILEI, nu al browserului, si o
 * fila duplicata (Ctrl+click pe fila) il mosteneste - dar atunci si portalul
 * vechi are aceeasi hiba, si nu se repara aici.
 */
export function tabSession(session: string): string {
  const KEY = 'od-v4-tab'
  let tab = ''

  try {
    tab = window.sessionStorage.getItem(KEY) ?? ''
    if (tab === '') {
      /* Ceasul in secunde ca in portal, plus patru cifre la intamplare: doua
         file deschise in aceeasi secunda ar fi luat acelasi numar. */
      tab = `${Math.round(Date.now() / 1000)}${Math.floor(Math.random() * 9000 + 1000)}`
      window.sessionStorage.setItem(KEY, tab)
    }
  } catch {
    /* Un browser cu depozitarea inchisa nu e un motiv sa nu mearga ecranul:
       numele ramane doar al conexiunii asteia, si se pierde la reincarcare. */
    tab = `${Math.round(Date.now() / 1000)}${Math.floor(Math.random() * 9000 + 1000)}`
  }

  return session + tab
}
